import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BrowserPlatformService {
  constructor(@Inject(DOCUMENT) private doc: Document) {}

  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  createObjectUrl(data: Blob): string {
    return window.URL.createObjectURL(data);
  }

  revokeObjectUrl(url: string): void {
    window.URL.revokeObjectURL(url);
  }

  downloadBlob(url: string, fileName: string): void {
    const anchor = this.doc.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.click();
  }

  printCurrentPage(): void {
    window.print();
  }
}
